<template>
  <div>
    <!-- Total solicitudes registradas -->
    <TotalComplaints
      :styleWidth="'w-80'"
      :total="count"
      title="Total de quejas"
      body="quejas registradas"
    />

    <!-- Filtro de busqueda de solicitudes -->
    <ManagementFilter
      :activeKey="activeTab"
      :loading="loading"
      :searching="searching"
      @getFilterForm="setFilterForm"
    />

    <!-- Tabla de datos de solicitudes -->
    <div class="w-full grid grid-cols-12 gap-4 mb-2 mx-4 mt-4">
      <div class="col-span-12 text-left">
        <!-- Contenedor principal de las pestañas de Ant Design Vue -->
        <a-tabs :activeKey="activeTab" @change="handleTabChange">
          <!-- Pestaña 1: Ver lista de quejas -->
          <a-tab-pane key="1" tab="Ver lista de quejas">
            <div
              class="bg-white overflow-x-auto rounded-xl border border-gray-300 mx-4 mt-4 search-complaints"
            >
              <div
                class="p-4 flex justify-start mt-4"
                v-if="complaintsEmisores.length > 0"
              >
                <a-menu mode="horizontal">
                  <a-sub-menu>
                    <a-button
                      slot="title"
                      type="primary"
                      style="margin-bottom: 16px"
                      v-on:click="collapsed = !collapsed"
                    >
                      <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" />
                    </a-button>
                    <a-menu-item v-if="collapsed">
                      <vue-excel-xlsx
                        :dataSheets="[complaintsEmisores]"
                        :sheetNames="['Reporte']"
                        book
                        :transpose="[false, true]"
                        :columnsSheets="[columnsExcel]"
                        file-name="Quejas Agiliza"
                      >
                        <span class="mx-2">Descargar vista actual XLSX</span>
                      </vue-excel-xlsx>
                    </a-menu-item>

                    <a-menu-item
                      v-if="collapsed"
                      @click="() => generateInfoSolip('xlsx')"
                    >
                      <span class="mx-2"> Descargar reporte completo XLSX</span>
                    </a-menu-item>
                    <a-menu-item
                      v-if="collapsed"
                      @click="() => generateInfoSolip('csv')"
                    >
                      <span class="mx-2"> Descargar reporte completo CSV</span>
                    </a-menu-item>
                  </a-sub-menu>
                </a-menu>
              </div>

              <!-- Tabla de datos de solicitudes -->
              <ManagementTable
                :dataSource="complaintsEmisores"                 
              />

              <div class="p-4 flex justify-end">
                <a-pagination
                  v-model="page"
                  :page-size="pageSize"
                  :page-size-options="pageSizeOptions"
                  :total="count"
                  show-size-changer
                  size="large"
                  @showSizeChange="onShowSizeChange"
                  @change="onChange"
                />
              </div>
            </div>
          </a-tab-pane>

          <!-- Pestaña 2: Ver sesiones en lista  -->
          <a-tab-pane key="2" tab="Ver sesiones en lista">
            <div
              class="bg-white overflow-x-auto rounded-xl border border-gray-300 mx-4 mt-4 search-complaints"
            >
              <!-- Tabla de datos de sesiones -->
              <ManagementAgilizaEvTable
                :dataSource="sessionsAgiliza"
                @accessSession="handleAccessSession"
                @goToSessionDetail="handleGoToSessionDetail"
                @viewSessionDetails="handleViewSessionDetails"                
              />
            </div>
          </a-tab-pane>

          <!-- Pestaña 3: Ver sesiones en calendario -->
          <a-tab-pane key="3" tab="Ver sesiones en calendario">
            <div class="h-screen max-h-[80vh]">
              <SessionsAgilizaEvCalendar
                :events="sessionsAgiliza"
                @refresh="fetchData"
              />
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <Modal v-if="viewModal" size="md">
      <div class="text-center">
        <p class="mt-4">{{ msgToModal }}</p>
        <button
          @click="closeModal"
          class="mt-4 py-2 px-4 bg-blue-500 text-white rounded-lg"
        >
          ACEPTAR
        </button>
      </div>
    </Modal>

    <!-- Modal de detalle de sesión -->
    <SessionAgilizaEvDetailModal
      :visible="isModalVisible"
      :session-data="selectedSessionData"
      @close="closeModal"
      @access="handleAccessSession(selectedSessionData)"
      @goToSessionDetail="handleGoToSessionDetail(selectedSessionData)"
      @reschedule="handleRescheduleSession"      
    />
  </div>
</template>

<script>
import ManagementFilter from "../partials/ManagementFilter.vue";
import ManagementTable from "../partials/ManagementTable.vue";
import ManagementAgilizaEvTable from "../partials/ManagementAgilizaEvTable.vue";
import SessionsAgilizaEvCalendar from "../partials/SessionsAgilizaEvCalendar.vue";
import TotalComplaints from "@/components/Dashboard/Complaints/TotalComplaints.vue";
import complaintsAgilizaServicesImplementation from "@/feature/dashboard/complaints_agiliza/data/services/complaints_agiliza_services_impl";
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "@/core/utils/constants";
import ErrorMessaje from "@/core/error/error_messaje";
import SessionAgilizaEvDetailModal from "../partials/SessionAgilizaEvDetailModal.vue";

let columnsExcelBackup = [];
columnsExcelBackup.push(
  { label: "Código de queja", field: "codigo_queja" },
  { label: "Motivo de queja", field: "macro_motivo_cod" },
  { label: "Tipo de identificación", field: "tipo_id_CF" },
  { label: "No. de identificación", field: "numero_id_CF" },
  { label: "Fecha de creación", field: "fecha_creacion" },
  { label: "Estado", field: "estado_cod" },
);
export default {
  components: {
    TotalComplaints,
    ManagementFilter,
    ManagementTable,
    ManagementAgilizaEvTable,
    SessionsAgilizaEvCalendar,    
    SessionAgilizaEvDetailModal
  },
  data() {
    return {
      activeTab: "1",
      sessionsAgilizaType: "Ver lista de quejas",
      columnsExcel: columnsExcelBackup,
      collapsed: false,
      count: 0,
      loading: false,
      form: {},
      page: DEFAULT_PAGE,
      pageSize: DEFAULT_PAGE_SIZE,
      pageSizeOptions: ["50", "100", "150", "200", "250"],
      searching: false,
      complaintsEmisores: [],
      sessionsAgiliza: [],
      msgToModal: "",
      viewModal: false,
      isModalVisible: false,
      selectedSessionData: {},
    };
  },
  methods: {
    handleTabChange(key) {
      switch (key) {
        case "1":
          this.sessionsAgilizaType = "Ver lista de quejas";
          break;
        case "2":
          this.sessionsAgilizaType = "Ver sesiones en lista";
          break;
        case "3":
          this.sessionsAgilizaType = "Ver sesiones en calendario";
          break;
        default:
          this.sessionsAgilizaType = "Ver lista de quejas";
      }
      this.activeTab = key;
    },
    async setFilterForm(form, pagination) {
      this.form = form;
      if (pagination.page && pagination.pageSize) {
        this.page = pagination.page;
        this.pageSize = pagination.pageSize;
      }
      await this.fetchData();
    },

    async fetchData() {
      this.loading = true;
      this.searching = true;
      const pagination = {
        page: this.page,
        pageSize: this.pageSize,
      };

      let isGetCount = false;
      try {
        const response =
          await complaintsAgilizaServicesImplementation.getComplaintAgilizaList(
            pagination,
            this.form,
            isGetCount,
          );

        if (response.isSuccess) {
          try {
            isGetCount = true;
            const responseCount =
              await complaintsAgilizaServicesImplementation.getComplaintAgilizaList(
                pagination,
                this.form,
                isGetCount,
              );

            if (responseCount.isSuccess) {
              response.count = responseCount.data.count;
              this.setDeafultEmited(response.count, response.data);
              this.prepareSessionsAgiliza(response.data);
              return;
            } else {
              this.showToast("error", responseCount.message);
              this.setDeafultEmited(null);
              return;
            }
          } catch (error) {
            this.showToast("error", ErrorMessaje.internalServerError);
            this.setDeafultEmited(null);
          } finally {
            this.loading = false;
            this.searching = false;
          }

          // this.setDeafultEmited(response.data);
          return;
        } else {
          this.showToast("error", response.message);
          this.setDeafultEmited(null);
          return;
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
        this.setDeafultEmited(null);
      } finally {
        this.loading = false;
        this.searching = false;
      }
    },
    async generateInfoSolip(typeExport) {
      this.loading = true;
      this.searching = true;

      try {
        const response =
          await complaintsAgilizaServicesImplementation.generateReportAgilizaEv(
            typeExport,
            this.form,
          );

        if (response.isSuccess) {
          const link = document.createElement("a");
          link.href = response.data.url;
          link.setAttribute("download", "solip_file");
          document.body.appendChild(link);
          link.click();
        } else {
          this.showToast("error", ErrorMessaje.generalError);
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
      } finally {
        this.loading = false;
        this.searching = false;
        return;
      }
    },
    setDeafultEmited(count, resp) {
      this.count = count || 0;
      const data = resp?.results || [];

      const optionsStatesAgilizaEv =
        this.formOptions?.optionsStatesAgilizaEv || [];

      if (data.length > 0) {
        this.complaintsEmisores = data.map((element) => {
          // The 'T' is replaced by a space for better readability in the table.
          const formattedDate = element.agiliza_data.fecha_creacion.replace(
            "T",
            " ",
          );

          const optionsState =
            optionsStatesAgilizaEv.find(
              (opt) => opt.id === element.agiliza_data.estado.estado_id,
            ) || null;

          return {
            ...element,
            fecha_creacion: formattedDate,
            estado_cod: optionsState ? optionsState.name : "",
          };
        });
      } else {
        this.complaintsEmisores = [];
      }
    },
    prepareSessionsAgiliza(resp) {
      const data = resp?.results || [];

      this.sessionsAgiliza = data.filter(
        (item) =>
          item.agiliza_data &&
          !Array.isArray(item.agiliza_data) &&
          Array.isArray(item.agiliza_data.sessions) &&
          item.agiliza_data.sessions.length > 0,
      );

      this.sessionsAgiliza = this.sessionsAgiliza
        .filter((item) => item.agiliza_data?.sessions?.length > 0)
        .map((item) => ({
          ...item.agiliza_data.sessions[0],
          codigo_queja: item.codigo_queja ? String(item.codigo_queja) : "",
          reason_name: item.macro_motivo_cod,
          tipo_id_CF: item.tipo_id_CF,
          numero_id_CF: item.numero_id_CF,
        }));

      this.sessionsAgiliza = this.sessionsAgiliza.map((element) => {
        const sessionDate = element.session_date
          ? `${this.formatSessionDate(
              element.session_date,
            )} ${this.formatSessionTime(element.session_start_time)} - ${this.formatSessionTime(element.session_end_time)}`
          : "Pendiente";

        const formattedDate = element.creation_date
          ? element.creation_date.replace("T", " ")
          : "";
        return {
          ...element,
          session_date_original: element.session_date,
          session_date: sessionDate,
          creation_date: formattedDate,
        };
      });
    },
    formatSessionDate(fecha) {
      const [year, month, day] = fecha.split("-");

      const date = new Date(year, month - 1, day);

      const mes = date.toLocaleString("es-ES", {
        month: "long",
      });

      return `${day} de ${
        mes.charAt(0).toUpperCase() + mes.slice(1)
      } de ${year}`;
    },
    formatSessionTime(time) {
      if (!time) {
        return "";
      }

      return new Date(`1970-01-01T${time}`).toLocaleTimeString("es-CO", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    },
    closeModal() {
      this.viewModal = false;
      this.fetchData();
    },
    // Cambio de tamaño de página
    onShowSizeChange(page, page_size) {
      // Ante el cambio en el tamaño de la pagina se debe reiniciar la página a 1
      this.page = 1;
      this.pageSize = page_size;
      this.fetchData();
    },
    // Cambio de página
    onChange(page, page_size) {
      this.page = page;
      this.pageSize = page_size;
      this.fetchData();
    },
    showToast(result = "info", msg) {
      this.$notification[result]({
        message: "Resultado",
        description: msg,
        onClick: () => {},
      });
    },
    handleAccessSession(record) {
      if (record && record.session_link) {
        window.open(record.session_link, "_blank");
      }
    },
    async handleRescheduleSession() {
      try {
        const response =
          await complaintsAgilizaServicesImplementation.rescheduleSessionAgiliza(
            this.selectedSessionData.session_agiliza_id,
          );

        if (response.isSuccess) {
          this.showToast("info", response.data.message);
        } else {
          let errorMsg = ErrorMessaje.generalError;
          if (response.data && response.data.message) {
            errorMsg = response.data.message;
          }
          this.showToast("error", errorMsg);
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
      } finally {
        this.closeModal();
        this.fetchData();
      }
    },
    handleViewSessionDetails(record) {
      this.selectedSessionData = record;
      this.isModalVisible = true;
    },
    handleGoToSessionDetail(record) {      
      this.$router.push(`/dashboard/complaints-agiliza/details?complaint_id=${record.codigo_queja}&type=agiliza&action=sesion`);              
    },
    closeModal() {
      this.isModalVisible = false;
      this.selectedSessionData = {};
    },
  },
  computed: {
    formOptions: function () {
      return this.$store.state.form;
    },
  },
};
</script>

<style></style>
